import styled from 'styled-components';
import { createButtonElement, getButtonStyles } from './ButtonHelpers';
const StyledButton = styled.button `
	${(props) => getButtonStyles(props.$buttonProps, props.theme)}
`;
const Button = createButtonElement(StyledButton, 'Button');
export default Button;
//# sourceMappingURL=Button.js.map